import { CanActivate, Router } from "@angular/router";
import { Inject, Injectable } from "@angular/core";

import { WINDOW } from '@app/lib/services/window.service';

@Injectable()
export class AccessRequiredGuard implements CanActivate {
  
  constructor(
    @Inject(WINDOW)
    private readonly window: Window,

    private readonly router: Router
  ) {}

  canActivate(): boolean {
    const url = new URL(this.window.location.href);
    const error = url.searchParams.get('error');

    if (error && error === 'access_denied') {
      this.router.navigateByUrl('/access-denied');
      
      return false;
    }

    return true;
  }
}
